import { UserRoles } from '../../enums';

export const USER_ROLE_LABEL_MAPPING: Partial<Record<UserRoles, string>> = {
  [UserRoles.ACCOUNT_OWNER]: 'Account owner',
  [UserRoles.TEAM_MEMBER]: 'Team member',
  [UserRoles.ACCOUNT_ADMIN]: 'Account admin'
};
